import React, { Component, useState } from 'react';
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { DataTable } from 'primereact/datatable';
import { CSVLink, CSVDownload } from "react-csv";
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import UserService from '../../services/UserService';
import * as xlsx from 'xlsx';
import CountryService from '../../services/CountryService';
import CompanyMasterService from '../../services/CompanyMasterService';
import { Button } from 'primereact/button';
//import { CSVLink, CSVDownload } from "react-csv";
import { InputText } from 'primereact/inputtext';
import SecondaryReportService from '../../services/SecondaryReportService';
import tableRequest from '../../models/tableRequest.js';
import { confirmAlert } from 'react-confirm-alert'; // Import
import { ConfirmationModal } from '../../template/ConfirmationModal';
import MessageComponent from '../../template/Message';
import $, { contains } from 'jquery';
import ApiService from '../../services/apiService';
import Loaders from '../../template/Loaders';
import { TabView, TabPanel } from 'primereact/tabview';
import { FileUpload } from "primereact/fileupload";
import ReactDOM from 'react-dom';
import PrintSecondaryPackagingServiceManualAll from '../../services/PrintSecondaryPackagingServiceManualAll';
//import CompanyMasterService from '../../services/CompanyMasterService';

// Manage Dealer data
export default class SchemeManualReport extends Component {

    constructor(props) {
        super(props);
        this.surveyLink = React.createRef();

        this.ApiService = new ApiService();
        this.SecondaryReportService = new SecondaryReportService();
        this.UserService = new UserService();
        this.CompanyMasterService = new CompanyMasterService();
        this.CountryService = new CountryService();
        this.PrintSecondaryPackagingServiceManualAll = new PrintSecondaryPackagingServiceManualAll();
        this.tblResponse = new tableRequest();
        this.state = {
            FromDate: new Date(),
            ToDate: new Date(),
            visible: false,
            ReferenceID: '',
            updateLoader: false,
            sortIcon: false,
            UserName: '',
            ship_City: '',
            MaterialCode: '',
            ship_State: '',
            ship_Country: '',
            materialDDL: [],
            ship_Address1: '',
            ship_Address2: '',
            ship_Pincode: '',
            companyDDL: [],
            bill_City: '',
            bill_State: '',
            bill_Country: '',
            bill_Address1: '',
            bill_Address2: '',
            bill_Pincode: '',
            FromNo: '',
            ToNo: '',
            MaterialNumber: '',
            LastName: '',
            Email: '',
            MobileNo: '',
            Password: '',
            ConfirmPassword: '',
            IsActive: false,
            sortOrder: '1',
            UserType: 2,//distributor
            CompanyId: '',
            companyDDL: [],
            formError: {
                ship_Country: '',
                UserName: '',
                ship_City: '',
                ship_State: '',
                bill_City: '',
                bill_State: '',
                MaterialNumber: '',
                LastName: '',
                Password: '',
                bill_Country: '',
                Email: '',
                ConfirmPassword: '',
                MobileNo: '',
                bill_Pincode: '',
                bill_Address1: '',
                bill_Address2: '',
                ship_Pincode: '',
                ship_Address1: '',
                ship_Address2: '',
                CompanyId: '',
                FromNo: '',
                ToNo: '',
                allData: []
            },

            formHeading: 'Add Retailer',
            buttonLabel: 'Submit',
            sales: [],
            ship_citySelectItems: [],
            ship_stateSelectItems: [],
            ship_countrySelectItems: [],
            bill_citySelectItems: [],
            bill_stateSelectItems: [],
            bill_countrySelectItems: [],
            loading: true,
            first: 0,
            rows: 5,
            totalRecords: 0,
            globalFilter: null,
            allData: [],
            emptyMessage: 'No Data found',
            compDisabled: false
        }


        this.actionTemplate = this.actionTemplate.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.SameAsBilling = this.SameAsBilling.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.handleCodeChange = this.handleCodeChange.bind(this);
        this.FilterData = this.FilterData.bind(this);
        //  this.submitForm1 = this.submitForm1.bind(this);
        this.hideFunc = this.hideFunc.bind(this);
        this.hideFunc1 = this.hideFunc1.bind(this);
        this.onPage = this.onPage.bind(this);
        this.searchFilter = this.searchFilter.bind(this);
        this.openDialog = this.openDialog.bind(this);
        this.openDialog1 = this.openDialog1.bind(this);
        this.onSort = this.onSort.bind(this);
        this.handlePlantChange = this.handlePlantChange.bind(this);
        this.GetReportExport = this.GetReportExport.bind(this);
    }
    //trigger api function on page call
    componentDidMount() {



        debugger;
        setTimeout(() => {
            var date = new Date();
            date.setDate(date.getDate() - 7);
            this.tblResponse.FromDate = date.toLocaleDateString();
            this.tblResponse.ToDate = new Date().toLocaleDateString();
            this.setState({
                FromDate: date,
                ToDate: new Date()
            });
            this.GetUsers();
            this.GetCompany();
            this.GetMaterialCode();
        }, 1000);
        $('.p-column-title').on('click', function () {
            $(this).next().removeClass('pi-sort').toggleClass('pi-sort-up').addClass('pi-sort-down');
        });

        this.GetCountry();
    }
    onChange = date => this.setState({ FromDate: '', ToDate: '' })
    //loading page 
    onPage(event) {


        this.setState({
            loading: true
        });

        //imitate delay of a backend call
        setTimeout(() => {
            this.getLazyLoadingValues(event);
            this.GetUsers();
            this.GetCompany();
            this.GetMaterialCode();

        }, 250);
    }
    FilterData() {
        debugger;
        this.tblResponse.FromDate = this.state.FromDate.toLocaleDateString();
        this.tblResponse.ToDate = this.state.ToDate.toLocaleDateString();
        this.GetUsers();
    }

    // get list data
    getLazyLoadingValues(event) {
        debugger;
        const fromDate = new Date(this.state.FromDate);
        const toDate = new Date(this.state.ToDate);
        this.setState({ rows: event.rows });
        this.tblResponse.PageSize = event.rows;
        this.tblResponse.First = event.first + 1;
        this.tblResponse.IsActive = '1';
        this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
        //this.tblResponse.SortColumn = event.sortField;
        this.tblResponse.SortOrder = event.sortOrder === 1 ? 'ASC' : 'DESC';
        this.tblResponse.FromDate = fromDate.toLocaleDateString();
        this.tblResponse.ToDate = toDate.toLocaleDateString();
        // this.tblResponse.Company = this.state.selectedPlant;
        // this.tblResponse.MaterialCode = this.state.selectedCode;
        this.tblResponse.Company = this.state.Company;
        this.tblResponse.MaterialCode = this.state.MaterialCode;
    }

    //to get country data
    GetCountry() {

        this.CountryService.GetCountries('101').then(data => {
            const resdata = data.data;
            if (resdata !== null && resdata.ResponseData !== null && resdata.ResponseData.length > 0) {

                this.state.ship_countrySelectItems = resdata.ResponseData;
                this.state.bill_countrySelectItems = resdata.ResponseData;

            }
        });
    }

    SetState(cCode, fieldName) {


        if (fieldName == 'bill_Country') {
            const resdata = this.state.allstate.filter(x => x.CountryId == cCode);
            this.setState({
                "bill_stateSelectItems": resdata
            });

        }
        if (fieldName == 'ship_Country') {
            const resdata = this.state.allstate.filter(x => x.CountryId == cCode)
            this.setState({
                "ship_stateSelectItems": resdata
            });
        }
    }
    SetCity(sCode, fieldName) {
        if (fieldName == 'bill_State') {
            const resdata = this.state.allcity.filter(x => x.StateId == sCode);
            this.setState({
                "bill_citySelectItems": resdata
            });
        }
        if (fieldName == 'ship_State') {
            const resdata = this.state.allcity.filter(x => x.StateId == sCode);
            this.setState({
                "ship_citySelectItems": resdata
            });
        }
    }





    // get users data list from api
    GetUsers(isExport) {
        this.SecondaryReportService.GetSecondaryManualReport(this.tblResponse).then(data => {
            debugger;
            const resdata = data.data;
            this.setState({ updateLoader: true });
            //if response data not null
            if (resdata !== null && resdata.ResponseData !== null && resdata.ResponseData.length > 0) {
                this.datasource = resdata.ResponseData;
                this.setState({
                    totalRecords: resdata.ResponseData[0].TotalRows,
                    first: (this.tblResponse.First - 1),
                    sales: this.datasource.slice(0, ((this.tblResponse.First - 1) + this.tblResponse.PageSize)),
                    loading: false

                });
                // if(isExport)
                // {
                //  this.setState({
                //  allData: resdata.ResponseData
                //  });

                //  this.setState({ allData: resdata.ResponseData }, () => {
                //      this.surveyLink.link.click()
                // });
                // }

                //    {
                //     this.setState({
                //     allData: resdata.ResponseData
                //     });

                //     this.setState({ allData: resdata.ResponseData }, () => {
                //         this.surveyLink.link.click()
                //    });
                //    }


            }
            //if response data null
            //  else {
            //     this.datasource = null;
            //     this.setState({
            //         totalRecords: 0,
            //         first: 1,
            //         sales: null,
            //         loading: false
            //     });
            // }
            else {
                this.datasource = null;
                this.setState({
                    totalRecords: 0,
                    first: 1,
                    sales: null,
                    loading: false
                });
            }
        });
    }
    // call every change of form and validation part also
    handleChange(event) {
        const { name, value } = event.target;
        //to validate each form field with required conditions
        switch (name) {
            case 'FromDate':
                if (value == null || !(value instanceof Date)) {
                    this.formIsValid = false;
                    this.refs.Messchild.showError("Please select from date.");
                    return;
                }
                else if (!(value.toLocaleDateString().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/))) {
                    this.formIsValid = false;
                    this.refs.Messchild.showError("Please enter only date.");
                    return;
                }
                else if ((value instanceof Date) && (this.state.ToDate instanceof Date)) {
                    const startDate = value;
                    const endDate = this.state.ToDate;
                    if (!(Date.parse(startDate) <= Date.parse(endDate))) {
                        this.formIsValid = false;
                        this.refs.Messchild.showError("From date must be less than to date.");
                        return;
                    }
                }

                break;
            case 'ToDate':
                if (value == null || !(value instanceof Date)) {
                    this.formIsValid = false;
                    this.refs.Messchild.showError("Please select to date.");
                    return;
                }
                else if (!(value.toLocaleDateString().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/))) {
                    this.formIsValid = false;
                    this.refs.Messchild.showError("Please enter only date.");
                    return;
                }
                else if ((value instanceof Date) && (this.state.FromDate instanceof Date)) {
                    const startDate = this.state.FromDate;
                    const endDate = value;
                    if (!(Date.parse(startDate) <= Date.parse(endDate))) {
                        this.formIsValid = false;
                        this.refs.Messchild.showError("To date must be greater than from date.");
                        return;
                    }
                }

                break;
            default:
                break;
        }

        this.setState({ [name]: value });
    }

    // call to update billing to shipping
    SameAsBilling(event) {
        if (event.target.checked) {
            this.setState({
                "ship_countrySelectItems": this.state.bill_countrySelectItems,
                "ship_stateSelectItems": this.state.bill_stateSelectItems,
                "ship_citySelectItems": this.state.bill_citySelectItems,
                "ship_Country": this.state.bill_Country,
                "ship_State": this.state.bill_State,
                "ship_City": this.state.bill_City,
                "ship_Address1": this.state.bill_Address1,
                "ship_Address2": this.state.bill_Address2,
                "ship_Pincode": this.state.bill_Pincode
            });

        }

    }

    // Validate form

    openDialog1() {
        this.setState({ visible1: true, uploadImagPath: '' });
        this.formReset();
    }

    // reset form text value
    formReset() {
        this.setState({
            ReferenceID: '',
            UserName: '',
            FirstName: '',
            LastName: '',
            Email: '',
            MobileNo: '',
            Password: '',
            ConfirmPassword: '',
            IsActive: true,
            ship_City: '',
            ship_State: '',
            ship_Country: '',
            ship_Address1: '',
            ship_Address2: '',
            ship_Pincode: '',
            bill_City: '',
            bill_State: '',
            bill_Country: '',
            bill_Address1: '',
            bill_Address2: '',
            bill_Pincode: '',


        });
        let errors = this.state.formError;
        Object.entries(errors).map(([key, value]) => {
            errors[key] = '';
        });
    }
    GetReportExport() {
        this.SecondaryReportService.GetReportExportManualReport(this.tblResponse).then(data => {
            const resdata = data.data;
            debugger
            //if response data not null
            if (resdata !== null && resdata.ResponseData !== null && resdata.ResponseData.length > 0) {
                debugger
                this.setState({
                    allData: resdata.ResponseData
                });

                this.setState({ allData: resdata.ResponseData }, () => {
                    this.surveyLink.link.click()
                });
            }
        });
    }
    handlePlantChange(event) {
        debugger
        this.tblResponse.Company = event.target.value
        this.setState({
            Company: event.target.value
        });
        this.GetUsers();
        this.GetMaterialCode();
    }
    handleCodeChange(event) {
        debugger
        this.tblResponse.MaterialCode = event.target.value
        this.setState({
            MaterialCode: event.target.value
        });

        this.GetUsers();
    }
    hideFunc() {
        this.setState({
            visible: false, buttonLabel: 'Submit',
            formHeading: 'Add Retailer'
        })
        this.formReset();
    }
    hideFunc1() {
        this.setState({
            visible1: false, buttonLabel: 'Submit',
            formHeading1: 'Upload Retailer'
        })
        this.formReset();
    }
    // open Dialog
    openDialog() {
        this.setState({ visible: true });
        this.formReset();
        this.state.ship_stateSelectItems = 0;
        this.state.bill_stateSelectItems = 0;
        this.state.ship_citySelectItems = 0;
        this.state.bill_citySelectItems = 0;
    }
    openDialog1() {
        this.setState({ visible1: true });
        this.formReset();

    }
    // submit form and create or update user
    submitForm(event) {
        debugger
        event.preventDefault();

        let isfrmvalid = true;
        let checkerror = this.state.formError;

        Object.entries(checkerror).map(([key, value]) => {
            const val = this.state[key]
            let valid = this.validateForm(val, key);
            if (!valid) {
                this.setState({ checkerror: isfrmvalid });
                isfrmvalid = false;
            }
        });

        if (isfrmvalid) {
            this.setState({ updateLoader: false });
            console.log(this.ship_City);
            const formData = {

            }

            setTimeout(() => {
                debugger
                this.UserService.CreateUpdateUser(formData).then(data => {
                    debugger
                    const resdata = data.data;
                    if (resdata !== null && resdata.ResponseCode === '200') {
                        this.refs.Messchild.showSuccess(resdata.ResponseMessage);
                        this.setState({
                            loading: true,
                            visible: false,
                            updateLoader: true
                        });
                        this.formReset();
                        this.GetUsers(this.tblResponse)
                    } else if (resdata.ResponseCode === '400') {
                        this.refs.Messchild.showWarn(resdata.ResponseMessage);
                        this.setState({
                            loading: true,
                            visible: false,
                            updateLoader: true
                        });

                    } else {
                        this.refs.Messchild.showError(resdata.ResponseMessage);
                        this.setState({
                            loading: true,
                            visible: false,
                            updateLoader: true
                        });

                    }
                });
            }, 1000);
            $('.p-column-title').on('click', function () {
                $(this).next().removeClass('pi-sort').toggleClass('pi-sort-up').addClass('pi-sort-down');
            });
        }
    }



    // delete user data




    // Search Filter
    searchFilter(e) {
        this.setState({
            loading: true
        });
        this.tblResponse.SearchValue = e.target.value;
        this.GetUsers(this.tblResponse);
    }

    callbackFunction = (childData) => {
        this.setState({ message: childData })
    }

    // disabled check box
    activeTemplate(rowData, column) {
        return (
            <input type="checkbox" disabled checked={rowData.IsActive} />
        )
    }
    GetMaterialCode() {
        debugger
        const selectedPlant = this.tblResponse.Company || "";
        this.CompanyMasterService.GetMaterialCodeDDL(selectedPlant).then(data => {
            debugger
            const resdata = data.data;

            if (resdata !== null && resdata.ResponseData !== null && resdata.ResponseData.length > 0) {

                this.setState({

                    materialDDL: resdata.ResponseData,

                });






            }
        });
    }
    GetCompany() {
        debugger
        this.CompanyMasterService.GetPlantDDL().then(data => {
            debugger
            const resdata = data.data;
            debugger
            if (resdata !== null && resdata.ResponseData !== null && resdata.ResponseData.length > 0) {

                this.setState({

                    companyDDL: resdata.ResponseData,

                });






            }
        });
    }
    // sort page 
    onSort(event) {
        debugger
        this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1, sortIcon: !this.state.sortIcon });
        const sortField = event.sortField == "CreatedDt" ? "CreatedDt" : event.sortField;
        this.tblResponse.SortColumn = sortField ? sortField : "";
        this.tblResponse.SortOrder = this.state.sortOrder === 1 ? 'DESC' : 'ASC';
        this.GetUsers(this.tblResponse);
    }

    // edit form 
    actionTemplate(rowData, column) {

        const editMode = (e) => {
            this.setState({
                buttonLabel: 'Update',
                formHeading: 'Update Retailer',
                visible: true, ReferenceID: rowData.ReferenceID,
                UserName: rowData.Username,
                FirstName: rowData.FirstName,
                LastName: rowData.LastName,
                Email: rowData.Email,
                MobileNo: rowData.MobileNo,
                Password: rowData.Password,
                ConfirmPassword: rowData.Password,
                IsActive: rowData.IsActive,
                ship_Address1: rowData.ship_Address1,
                ship_Address2: rowData.ship_Address2,
                ship_Pincode: rowData.ship_Pincode,
                bill_Address1: rowData.bill_Address1,
                bill_Address2: rowData.bill_Address2,
                bill_Pincode: rowData.bill_Pincode,

            });

            const CompanyObj = this.state.companyDDL.filter(x => x.CompId == rowData.CompanyId)

            const ship_CountryObj = this.state.ship_countrySelectItems.filter(x => x.CountryId == rowData.ship_Country)
            const bill_CountryObj = this.state.bill_countrySelectItems.filter(x => x.CountryId == rowData.bill_Country)
            // new add by ravinder 08082022
            // this.state.ship_stateSelectItems = this.state.allstate.filter(x => x.StateId == rowData.ship_State)
            // this.state.bill_stateSelectItems = this.state.allstate.filter(x => x.StateId == rowData.bill_State)
            // this.state.ship_citySelectItems = this.state.allcity.filter(x => x.CityId == rowData.ship_City)
            // this.state.bill_citySelectItems= this.state.allcity.filter(x => x.CityId == rowData.bill_City)
            ///end
            this.state.ship_stateSelectItems = this.state.allstate;
            this.state.bill_stateSelectItems = this.state.allstate;
            this.state.ship_citySelectItems = this.state.allcity;
            this.state.bill_citySelectItems = this.state.allcity;
            const ship_CityObj = this.state.ship_citySelectItems.filter(x => x.CityId == rowData.ship_City)
            const bill_CityObj = this.state.bill_citySelectItems.filter(x => x.CityId == rowData.bill_City)
            const ship_StateObj = this.state.ship_stateSelectItems.filter(x => x.StateId == rowData.ship_State)
            const bill_StateObj = this.state.bill_stateSelectItems.filter(x => x.StateId == rowData.bill_State)



            this.setState({
                ship_Country: ship_CountryObj[0],
                bill_Country: bill_CountryObj[0],
                ship_State: ship_StateObj[0],
                bill_State: bill_StateObj[0],
                ship_City: ship_CityObj[0],
                bill_City: bill_CityObj[0],
                CompanyId: CompanyObj[0]
            });
        }

        const deleteFunc = () => {

            confirmAlert({
                title: 'Confirm to delete',
                message: 'Are you sure to do this.',
                buttons: [
                    {
                        label: 'Yes',
                        onClick: () => this.deleteUser(rowData.ReferenceID)

                    },
                    {
                        label: 'No',
                        onClick: () => null
                    }
                ]
            });
        }

        return <span>
            <Button type="button" icon="pi pi-pencil" onClick={editMode} className="p-button-warning" style={{ marginRight: '3px' }}></Button>
            <Button type="button" icon="pi pi-trash" onClick={deleteFunc} className="p-button-danger"></Button>
        </span>;
    }
    actionTemplate(rowData, column) {
        const editMode = (e) => {
            debugger
            this.PrintSecondaryPackagingServiceManualAll.formPreview1([rowData]);
            ////PRINT SLIP
        }
        return <span>
            <Button type="button" icon="pi pi-print" onClick={editMode} className="p-button-warning" style={{ marginRight: '3px' }}></Button>

        </span>;
    }

    // create html part
    //resolved KREP-36
    render() {
        let header = (
            <div className='row' style={{ 'textAlign': 'right' }}>
                <div className="col-md-9">
                    <form className="form-inline row">
                        <div className="col-md-7 d-flex flex-row flex-nowrap" style={{ gap: '5px' }}>
                            <div className="form-group">
                                <Calendar value={this.state.FromDate} name="FromDate" onChange={this.handleChange} appendTo={document.getElementById('root')} placeholder="From Date" />
                            </div>

                            <div className="form-group">
                                <Calendar value={this.state.ToDate} name="ToDate" onChange={this.handleChange} appendTo={document.getElementById('root')} placeholder="To Date" />
                            </div>
                            <button type="button" onClick={this.FilterData} className="btn btn-primary ml-3">Submit</button>
                        </div>

                        <div className='col-md-5 d-flex flex-row flex-nowrap' style={{ gap: '5px' }}>
                            <select id='plant' className='form-control w-50'
                                onChange={this.handlePlantChange} value={this.state.selectedPlant}>
                                <option value="0">Select All Plant</option>
                                {this.state.companyDDL.map(plant => (
                                    <option key={plant.Plant} value={plant.Plant}>{plant.Plant}</option>
                                ))}
                            </select>

                            <select id='product' className='form-control w-50'
                                onChange={this.handleCodeChange} value={this.state.selectedCode}>
                                <option value="0">Select All Product Code</option>
                                {this.state.materialDDL.map(MaterialCode => (
                                    <option key={MaterialCode.MaterialCode} value={MaterialCode.MaterialCode}>{MaterialCode.MaterialCode}</option>
                                ))}
                            </select>
                        </div>


                    </form>
                </div>

                <div className="col-md-3">
                    <div className="row text-right" >
                        <i className="pi pi-search" style={{ margin: '4px 4px 0 0' }}></i>
                        <InputText type="search" className='form-control' style={{ width: '60%' }} onInput={this.searchFilter} placeholder="Global Search" />
                        <button className="btn btn-primary ml-2 export-disabled"
                            target="_blank" disabled={this.state.sales == null} onClick={this.GetReportExport}>Export</button>
                        <CSVLink
                            hidden={true}
                            data={this.state.allData}
                            ref={(r) => this.surveyLink = r}
                            filename={"Secondary Packing Manual.csv"}
                        >
                        </CSVLink>
                    </div>
                </div>
            </div>
        );
        return (
            <>
                <MessageComponent ref="Messchild" />
                <Loaders loader={this.state.updateLoader} />
                <ConfirmationModal parentCallback={this.callbackFunction} ref="child" />
                <div className="heading">
                    <div className='row'>
                        <div className='col-sm-7'>
                            <h1>Secondary Packing Manual Report</h1>
                        </div>
                        {/* <div className='col-sm-5'>
                            <a className="btn btn-primary ml-2" icon="FaFileDownload" style={{ height: '34px' }} href={require('../../assets/ExcelTemplate/Uploadretailer.xlsx')} download="UploadRetailer.xlsx">Download Template </a>
                          
                            <Button label="Upload " icon="pi pi-plus-circle" onClick={this.openDialog1} />
                        </div> */}
                    </div>
                </div>

                <DataTable exportFilename="Secondary Packing Report" scrollable responsive={true} header={header} globalFilter={this.state.globalFilter}
                    emptyMessage={this.state.emptyMessage} value={this.state.sales} paginator={true}
                    rows={this.state.rows} rowsPerPageOptions={[5, 10, 20, 50, 100]} totalRecords={this.state.totalRecords} lazy={true} first={this.state.first}
                    onPage={this.onPage} onSort={this.onSort} ref={(el) => { this.dt = el; }}>
                    {/* <Column field="CartonId" header="CartonId" style={{width:'150px'}} sortable={true} /> */}

                    <Column field="CartonId" header="CartonId" style={{ width: '200px' }} sortable={true} />

                    <Column field="MaterialNumber" header="Product Code" style={{ width: '100px' }} sortable="custom" />
                    <Column field="ProductName" header="Product Name" style={{ width: '250px' }} sortable="custom" />
                    <Column field="ProductDscrptn" header="Product Description" style={{ width: '250px' }} sortable="custom" />
                    <Column field="BatchNo" header="Batch No" style={{ width: '100px' }} sortable="custom" />
                    <Column field="Plant" header="Plant" style={{ width: '100px' }} sortable="custom" />
                    <Column field="StorageLocation" header="Storage Location" style={{ width: '100px' }} sortable="custom" />
                    {/* <Column field="CartonName" header="Carton Name"  style={{width:'100px'}} sortable={false} /> */}
                    <Column field="ManufactureDate" header="Manfacture Date" style={{ width: '100px' }} sortable="custom" />
                    <Column field="ExpiryDate" header="Expiry Date" style={{ width: '100px' }} sortable="custom" />
                    <Column field="ValuatedUnrestrictedStock" header="Valuated Unrestricted Stock" style={{ width: '100px' }} sortable={false} />
                    <Column field="Qty" header="Pack Quantity" style={{ width: '100px' }} sortable="custom" />
                    {/* <Column field="GW" header="G.W." style={{ width: '100px' }} sortable={true} />
                    <Column field="Contractor" header="Contractor" style={{ width: '100px' }} sortable={true} />
                    <Column field="Supervisor" header="Supervisor" style={{ width: '100px' }} sortable={true} />
                    <Column field="DateOfPack" header="Date Of Pack" style={{ width: '100px' }} sortable={true} /> */}
                    <Column field="CreatedDt" header="Created Date" style={{ width: '150px' }} sortable={true} />
                    <Column body={this.actionTemplate} header="Action" style={{ width: '100px' }} />
                </DataTable>

                <Dialog className="popup-modal"
                    style={{ width: '70%' }}
                    header={this.state.formHeading}
                    visible={this.state.visible}
                    modal={true} onHide={this.hideFunc}>

                </Dialog>


            </>
        )
    }
}